<template>
    <form autocomplete="off" class="loading-viewport">
        <CommonSpinner v-if="isLoading" :box="true" />
        <div class="row gy-3">
            <div class="col-lg-6">
                <label>Skill type </label>
                <select @change="skillTypeChange()" v-model="form.skill_category_id" class="form-select" >
                    <option disabled value="" >--select--</option>
                    <option v-for="(stOption, uIndex) in skillTypes" :key="uIndex" 
                    :value="stOption.id">{{stOption.title}}</option>
                </select>
            </div>
            <div class="col-lg-6">
                <label> Skill <span class="text-danger">*</span></label>
                <multiselect 
                    mode="single"
                    searchable
                    valueProp="id"
                    trackBy="title" label="title"
                    :options="skillOptions" 
                    v-model="form.skill_id" placeholder="--select skill --">
                    <template v-slot:option="{ option }">
                        <div class="">
                            <h6 class="mb-0">{{ option.title }}</h6>
                        </div>
                    </template>
                </multiselect>
                <div v-for="(item, index) in v$.form.skill_id.$errors"
                    :key="index" class="text-danger">
                    <span v-if="item.$message">{{ item.$message }}</span>
                </div>
            </div> 
            <div class="col-lg-6">
                <label for="experience_level_id" class="form-label">Experience Level <span class="text-danger">*</span></label>
                <select v-model="form.experience_level_id" class="form-select"
                    :class="{ 'is-invalid': v$.form.experience_level_id.$error }">
                    <option disabled value="" >--select level--</option>
                    <option v-for="(qlOption, uIndex) in experienceLevelOptions" :key="uIndex" 
                    :value="qlOption.id">{{qlOption.title}}</option>
                </select>
                <div v-for="(item, index) in v$.form.experience_level_id.$errors"
                    :key="index" class="invalid-feedback">
                    <span v-if="item.$message">{{ item.$message }}</span>
                </div>
            </div>
            <div class="col-lg-6">
                <label for="years_of_experience" class="form-label">Years of experience</label>
                <select v-model="form.years_of_experience" name="years_of_experience" 
                    id="years_of_experience" class="form-select">
                    <option disabled value="" >--year of experience--</option>
                    <option value="0"> Zero experience </option>
                    <option v-for="(option, uIndex) in 10" :key="uIndex" 
                    :value="option">{{option}} {{option > 1 ? 'years' : 'year' }} </option>
                </select>
            </div>
            <div class="col-12">
                <div class="d-flex mt-3 justify-content-end">
                    <b-button variant="primary" 
                    @click.prevent="editMode? update() : create()"
                     type="button">{{editMode? 'Update':'Submit'}}</b-button>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import { required, helpers, requiredIf } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";

export default {
    setup() {
        return { v$: useVuelidate() };
    },
    components:{
    },
    props:{
        editItem:{
            type: Object,
            default: null
        },
        editMode:{
            type: Boolean,
            default: false
        }
    },
    data(){
        return{
            isLoading: true,
            form: {
                skill_id: "",
                experience_level_id: "",
                years_of_experience: "",

                skill_category_id: "",
            },
            skillTypes:[],
            skillOptions:[],

            experienceLevelOptions:[]
        }
    },
    validations() {
        return {        
            form:{
                skill_category_id: {
                    required: helpers.withMessage("Skill type is required", required),
                },
                skill_id: {
                    required: helpers.withMessage("Skill is required", required),
                },
                experience_level_id: {
                    required: helpers.withMessage("Experience Level is required", required),
                },
                years_of_experience: {
                    required: helpers.withMessage("Years of experience is required", required),
                },
            },
        }
    },
    methods:{
        create() {
            this.v$.$validate().then(result =>{
                if (!result) { this.alertError(this.v$.$errors[0].$message); return };

                this.$store.dispatch("changeLoaderValue", true)
                this.$http.post('/candidate-skills/create', this.form)
                .then((response) => {
                    this.$store.dispatch("changeLoaderValue", false)
                    if(response.data.success){
                        this.$emit('addedItem', response.data.data)
                        this.resetForm();
                    }
                })
            })
        },
        update(){
            this.v$.$validate().then(result =>{
                if (!result) { this.alertError(this.v$.$errors[0].$message); return };
                this.$store.dispatch("changeLoaderValue", true)
                this.$http.post(`/candidate-skills/${this.editItem.id}/update`, this.form)
                    .then((response) => {
                        this.$store.dispatch("changeLoaderValue", false)
                        if(response.data.success){
                            this.$emit('updatedItem', response.data.data)
                            this.resetForm()
                        }
                    })
            
            })
        },
        resetForm(){
            this.v$.$reset()
            this.$emit("closeMe")
        },
        skillTypeChange(origin = true){
            this.skillOptions = []
            if(origin) { this.form.skill_id = null }

            this.isLoading = true;
            this.$http.get(this.absoluteApiUrl(`/skills?category_id=${this.form.skill_category_id}`))
                .then((response) => {
                this.isLoading = false;
                if(response.data.success){
                    this.skillOptions = response.data.data
                }
            })
        },
        getOptionData(){
            this.isLoading = true
            this.$http.get(this.absoluteApiUrl(`/attributes?type=EXPERIENCE_LEVEL`))
                .then((response) => {
                if(response.data.success){
                    this.experienceLevelOptions = response.data.data
                }
            })
            this.$http.get(this.absoluteApiUrl(`/categories?type=SKILL`))
                .then((response) => {
                if(response.data.success){
                    this.isLoading = false;
                    this.skillTypes = response.data.data
                }
            })
        },
    },
    created(){
        this.getOptionData()
        if(this.editMode){
            this.form = this.$filters.patchUpdatables(this.form, this.editItem);
            this.skillTypeChange(false)
        }
    }
}
</script>